export default class UserForm {
  public name: string = ''
  public email: string = ''
  public image: any = null
  public password: string = ''
  public newPassword: string = ''
  public newPasswordConfirmation: string = ''
  public currentPath: string = ''
  public userBlockId: number
  public deleteImage: boolean = false

  toFormData() {
    const formData = new FormData()

    try {
      if (this.image) {
        formData.append('image', this.image, `${new Date().getTime()}`)
      }
    } catch (error) {
      console.error('Error converting image to blob:', error)
    }
    if (this.name) {
      formData.append('name', this.name)
    }
    if (this.email) {
      formData.append('email', this.email)
    }
    if (this.currentPath) {
      formData.append('current_path', this.currentPath)
    }
    if (this.password) {
      formData.append('password', this.password)
    }
    if (this.userBlockId) {
      formData.append('user_block_id', this.userBlockId.toString())
    }
    if (this.deleteImage) {
      formData.append('delete_image', 'true')
    }
    if (this.newPassword) {
      formData.append('new_password', this.newPassword)
    }
    if (this.newPasswordConfirmation && this.isSamePass) {
      formData.append('new_password_confirmation', this.newPasswordConfirmation)
    }

    return formData
  }

  get isSamePass() {
    return this.newPassword === this.newPasswordConfirmation
  }
}
